export function initializeDataLayer(trigger) {
    if (trigger) {
        var inframe = false;

        function iniFrame() {
            if (window.location !== window.parent.location) {
                inframe = true;
            } else {
                inframe = false;
            }
        }

        iniFrame();

        if (inframe) {
            // Initialize dataLayer if it doesn't exist
            window.dataLayer = window.dataLayer || [];

            // Check if dataLayer.push has already been overridden
            
                // Cache the original push method
                // const originalPush = dataLayer.push;
                // dataLayer.originalPush = originalPush;
                // Safe stringify to avoid circular references
                function safeStringify(obj) {
                    const cache = new WeakSet();
                    return JSON.stringify(obj, (key, value) => {
                        if (typeof value === 'object' && value !== null) {
                            if (cache.has(value)) {
                                return; // Circular reference found, discard key
                            }
                            cache.add(value);
                        }
                        return value;
                    });
                }

                // Override the dataLayer.push method
                dataLayer.push = function() {
                    const args = Array.prototype.slice.call(arguments);
                    // dataLayer.originalPush(args);
                    // // originalPush.apply(dataLayer, args);
                    const newEvent = args[0];

                    // Ensure the event data is serializable
                    const serializableEvent = JSON.parse(safeStringify(newEvent));

                    // Post the event to the parent window
                    window.parent.postMessage({
                        eventType: "dataLayerUpdate",
                        eventData: serializableEvent
                    }, "*");
                };
        }
    }
}
